<div class="custom-card" data-cy="ai-tasks">
	<div>

		<div *ngIf="loading" class="p-4 text-center text-gray-600">
			<p>Loading...</p>
		</div>

		<p-table
			*ngIf="!loading && (modelSummaries?.length || 0) > 0"
			[paginator]="true"
			[responsiveLayout]="'scroll'"
			[rows]="5"
			[showCurrentPageReport]="true"
			[value]="modelSummaries"
			currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
			styleClass="p-datatable-sm p-datatable-gridlines"
		>
			<ng-template pTemplate="header">
				<tr>
					<th pSortableColumn="taskName">
						AI Tasks
						<p-sortIcon field="taskName"></p-sortIcon>
					</th>
					<th pSortableColumn="atRisk">
						At Risk
						<p-sortIcon field="atRisk"></p-sortIcon>
					</th>
					<th pSortableColumn="statusLabel">
						Status
						<p-sortIcon field="statusLabel"></p-sortIcon>
					</th>
					<th></th>
				</tr>
			</ng-template>

			<ng-template let-task pTemplate="body">
				<tr>
					<td>
            <span
							[ngClass]="
                task.isFinancial ? 'isFinancialText' : 'isNotFinancialText'
              "
						>
              {{ documentTypeToLabel(task.documentType) }}
            </span>
					</td>
					<td>
						{{
							task.isFinancial
								? (task.amount | number: '1.2-2')
								: task.amount
						}}
					</td>
					<td>
						@if (task.isAutoCompleted){
							<span class="p-tag p-tag-success">
								Auto Completed
							</span>
						} @else if (task.summaryData.length > 0){
						<span class="p-tag p-tag-warning">
              At Risk
            </span>
						} @else {
							<span *ngIf="!task.isValid" class="p-tag p-tag-danger">Alert</span>
						}
					</td>
					<td class="text-center" title="click on the arrow to go to task">
						<a (click)="goToTask(task)" title="go to task">
							<i class="pi pi-arrow-right"></i>
						</a>
					</td>
				</tr>
			</ng-template>
		</p-table>

		<div *ngIf="!loading && hasNoSummaryData" class="flex bg-white justify-content-center my-5 custom-card">
			<div class="bg-blue-50 p-3 text-center rounded text-gray-800">
				{{
					errorStatus === 403
						? 'No AI enabled tasks available'
						: 'No data available for the selected date range'
				}}
				<div class="pt-1">
					<a
						href="mailto:support@tyalls.com"
						*ngIf="errorStatus === 403"
						class="text-primary cursor-pointer ml-1"
					>
						To enable AI Tasks contact support&#64;tyalls.com
					</a>
				</div>
			</div>
		</div>
	</div>
</div> 
